import cryto from "crypto-js";
export default class PassportHandler {
  constructor(axiosHandler) {
    this.autenticando = false;
    this.axiosHandler = axiosHandler;
  }
  async auth(form) {
    var header = { "Content-Type": "application/json" };
    this.axiosHandler.prepare(
      process.env.VUE_APP_ASBACK + "/api/loginweb",
      header,
      form
    );
    await this.axiosHandler.exe();
    var rs = this.manejoAuth(
      this.axiosHandler.getStatus(),
      this.axiosHandler.getData()
    );
    var promise1 = Promise.resolve(rs);
    return promise1.then(function(value) {
      return value;
    });
  }
  setRouter(router) {
    this.router = router;
  }
  manejoAuth(status, data) {
    if (status === 200) {
      this.setLocalStorage(data.user, "user-as");
      return this.manejoOk(status, data);
    }
    var validData = data.error.detail != undefined ? data.error.detail : "";
    return this.manejoError(status, validData);
  }
  setLocalStorage(rs, key) {
    var cadena = JSON.stringify(rs);
    localStorage.setItem(key, cadena);
  }
  manejoError(status, data) {
    var rs = { status: status, detalle: data };
    return rs;
  }
  manejoOk(status, data) {
    var rs = { status: status, data: data };
    return rs;
  }
  getToken() {
    return JSON.parse(localStorage.getItem("token-as"));
  }
  isAuth() {
    var _this = this;
    var promise1 = Promise.resolve();
    return promise1.then(function() {
      var prepared = _this.prepareHeader();
      if (typeof prepared.auth === "undefined") {
        return _this.isTokenActivo(prepared);
      }
      return prepared;
    });
  }
  tomarToken() {
    var token = { token: false };
    try {
      var local = this.getToken();
      if (local != null) {
        token = local;
      }
    } catch (e) {
      console.log(e);
    }
    return token.token;
  }
  removePassport() {
    localStorage.removeItem("token-as");
    localStorage.removeItem("user-as");
    localStorage.removeItem("_");
  }
  getDatosUsuarios() {
    var user = this.getUsuario();
    if (user == null) {
      return false;
    }
    var agencia = "All Seasons";
    if (user.agencia != null) {
      agencia = user.agencia;
    }
    return {
      usuario: user.nombre,
      agencia: agencia,
      email: user.email,
      id: user.id,
      idagencia: user.identidad,
      nivel: user.nivel,
      cuit: user.cuit,
      uws: user.uws
    };
  }
  async isTokenActivo(header) {
    this.autenticando = true;
    this.axiosHandler.prepare(
      process.env.VUE_APP_ASBACK + "/api/validar-token",
      header
    );
    await this.axiosHandler.exe();
    this.autenticando = false;
    return this.manejoRsTokenActivo(
      this.axiosHandler.getStatus(),
      this.axiosHandler.getData()
    );
  }
  manejoRsTokenActivo(codigo, rs) {
    var data = { auth: false, detalle: "Error inesperado" };
    try {
      if (codigo == 200) {
        return { auth: true };
      }
      data.auth = false;
      data.detalle = rs.detail;
    } catch (e) {
      console.log(e);
      return { auth: false };
    }

    return data;
  }
  prepareHeader() {
    var token = this.tomarToken();
    if (!token) {
      return { auth: false, detalle: "No se detectó sesión." };
    }
    var pre = "Bearer ";
    return {
      "Content-Type": "application/json",
      Authorization: pre.concat(token)
    };
  }
  setNewToken(token) {
    // Ejexutado de Axios, en cada interaccion guarda el token nuevo ya que es renovado
    this.setLocalStorage({ token: token }, "token-as");
  }
  getUsuario() {
    return JSON.parse(localStorage.getItem("user-as"));
  }
  getAutenticando() {
    return this.autenticando;
  }
  guadarCryted(value, key) {
    try {
      const ciphertext = cryto.AES.encrypt(value, process.env.VUE_APP_ENC_KEY);
      localStorage.setItem(key, ciphertext.toString());
    } catch (e) {
      console.log(e);
    }
  }
  getEncripted(key) {
    const data = localStorage.getItem(key);
    const bytes = cryto.AES.decrypt(data, process.env.VUE_APP_ENC_KEY);
    var plaintext = bytes.toString(cryto.enc.Utf8);
    return plaintext;
  }
}
